import React, { useState } from 'react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isResourcesOpen, setIsResourcesOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleResourcesDropdown = () => {
        setIsResourcesOpen(!isResourcesOpen);
    };

    const navLinks = [
        { name: 'Home', path: '/', isActive: window.location.pathname === '/' },
        { name: 'Initiatives', path: '/initiatives', isActive: window.location.pathname === '/initiatives' },
        { name: 'Resources', path: '/services', isActive: window.location.pathname === '/services' },
        { name: 'AICEX-Africa', path: '/ai-coe', isActive: window.location.pathname === '/ai-coe' },
        { name: 'News&Events', path: '/news-and-events', isActive: window.location.pathname === '/news-and-events' },
        // { name: 'Meet the Team', path: '/meet-the-team', isActive: window.location.pathname === '#' },
    ];

    const servicesLinks = [
        { name: 'Open Resources', path: 'https://microdata.aospea.org' },
        { name: 'SmartLearning', path: 'https://smartlearning.aospea.org' },
        { name: 'DataSpace', path: 'https://dataspace.aospea.org'}
    ];

    return (
        <header className="w-full p-4 mb-6 fixed top-0 left-0 z-50 bg-white shadow-lg">
            <div className="container mx-auto flex justify-between items-center">
                {/* Logo */}
                <div className="flex items-center">
                    <img
                        src="https://aospea.org/aosp-web-logo.png"
                        alt="AOSP Logo"
                        className="h-20 w-30 mr-4"
                    />
                </div>

                {/* Navigation Links */}
                <nav>
                    <ul className="hidden md:flex space-x-6 text-gray-700 font-medium">
                        {navLinks.map((link) => (
                            <li key={link.name} className="relative">
                                {link.name === 'Resources' ? (
                                    <button
                                        className="relative cursor-pointer hover:text-blue-500 transition duration-300"
                                        onClick={toggleResourcesDropdown}
                                    >
                                        <span className={`${link.isActive ? 'text-blue-500 font-semibold' : ''}`}>{link.name}</span>
                                        <span
                                            className={`absolute left-0 bottom-[-4px] w-full h-[2px] bg-blue-500 transform scale-x-0 transition-transform duration-300 ${link.isActive ? 'scale-x-100' : 'hover:scale-x-100'}`}
                                        ></span>

                                        {isResourcesOpen && (
                                            <ul className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-lg z-10">
                                                {servicesLinks.map((service) => (
                                                    <li key={service.name}>
                                                        <a
                                                            href={service.path}
                                                            target="_blank"
                                                            className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 transition duration-300"
                                                        >
                                                            {service.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </button>
                                ) : (
                                    <a
                                        href={link.path}
                                        className={`relative hover:text-blue-500 transition duration-300 ${link.isActive ? 'text-blue-500 font-semibold' : ''}`}
                                    >
                                        {link.name}
                                        <span
                                            className={`absolute left-0 bottom-[-4px] w-full h-[2px] bg-blue-500 transform scale-x-0 transition-transform duration-300 ${link.isActive ? 'scale-x-100' : 'hover:scale-x-100'}`}
                                        ></span>
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            className="text-gray-700 focus:outline-none"
                            aria-label="Toggle menu"
                            onClick={toggleMenu}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </nav>
            </div>

            {/* Mobile Menu Dropdown */}
            {isMenuOpen && (
                <div className="md:hidden mt-4">
                    <ul className="space-y-2 text-gray-700 font-medium">
                        {navLinks.map((link) => (
                            <li key={link.name}>
                                {link.name === 'Resources' ? (
                                    <div className="relative">
                                        <button
                                            className="w-full text-left hover:text-blue-500 transition duration-300"
                                            onClick={toggleResourcesDropdown}
                                        >
                                            {link.name}
                                        </button>
                                        {isResourcesOpen && (
                                            <ul className="mt-2 pl-4 text-gray-700">
                                                {servicesLinks.map((service) => (
                                                    <li key={service.name}>
                                                        <a
                                                            href={service.path}
                                                            className="block hover:text-blue-500 transition duration-300"
                                                        >
                                                            {service.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                ) : (
                                    <a
                                        href={link.path}
                                        className={`block hover:text-blue-500 transition duration-300 ${link.isActive ? 'text-blue-500 font-semibold' : ''}`}
                                    >
                                        {link.name}
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
};

export default Header;
